import { render, staticRenderFns } from "./PointTransactionModal.vue?vue&type=template&id=7c63960f&scoped=true&"
import script from "./PointTransactionModal.vue?vue&type=script&lang=js&"
export * from "./PointTransactionModal.vue?vue&type=script&lang=js&"
import style0 from "./PointTransactionModal.vue?vue&type=style&index=0&id=7c63960f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63960f",
  null
  
)

export default component.exports